(function () {
  const AVAILABLE_TEXT = "DROP DISPONIBILE ORA";

  const showAvailable = (timer) => {
    const label = timer.querySelector(".contdown-bar__label");
    if (label) label.style.display = "none";
    const items = timer.querySelector(".countdown-bar__items");
    if (items && !items.dataset.dropDone) {
      items.dataset.dropDone = "1";
      items.innerHTML = '<span class="countdown-bar__number countdown-bar__available">' + AVAILABLE_TEXT + '</span>';
    }
  };

  const setNum = (timer, sel, val) => {
    const el = timer.querySelector(sel);
    if (el) el.textContent = val;
  };

  const initTimer = () => {
    const currentTime = new Date().getTime();
    const countDownTimer = document.querySelectorAll(".countdown-bar-js");

    countDownTimer.forEach((timer) => {
      const endTime = new Date(timer.dataset.date).getTime();
      const timeLeft = endTime - currentTime;

      if (isNaN(endTime) || timeLeft < 0) {
        showAvailable(timer);
        return;
      }

      const days = Math.floor(timeLeft / (1000 * 60 * 60 * 24));
      const hours = Math.floor((timeLeft % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((timeLeft % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((timeLeft % (1000 * 60)) / 1000);

      setNum(timer, ".countdown-bar__days.countdown-bar__number", days);
      setNum(timer, ".countdown-bar__hours.countdown-bar__number", hours);
      setNum(timer, ".countdown-bar__min.countdown-bar__number", minutes);
      setNum(timer, ".countdown-bar__sec.countdown-bar__number", seconds);
    });
  };

  document.addEventListener("shopify:section:load", function () {
    if (!document.hidden) {
      setInterval(initTimer, 1000);
    }
  });

  if (!document.hidden) {
    setInterval(initTimer, 1000);
  }

  initTimer();
})();